module.exports = __webpack_public_path__ + "img/flavor_blueberries.5da4b695.png";